/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Toaster } from 'sonner';
import { Check } from 'lucide-react';

export function AppToaster() {
    return (
        <Toaster
            expand
            position="top-center"
            closeButton
            className="toaster"
            theme="light"
            offset="calc(var(--header-height, 0px) + 0.75rem)"
            icons={{ success: <Check size={20} strokeWidth={2.5} /> }}
            toastOptions={{ unstyled: true }}
        />
    );
}
